export default __webpack_public_path__ + "static/media/icon-plus.fa3a1e82.svg";